const hookMixin = {
  beforeDestroy () {
    // удаление всех подписок на события
    this.$off()
    // console.log('destroyed ')
  }
}

export default hookMixin
